import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getJson, postJson } from '../helpers/RequestsHelper';

const MeetingsPage = (props) => {

  const { t } = useTranslation()

  const now = new Date()

  const [meetings, setMeetings] = useState()
  const [officeId, setOfficeId] = useState()
  const [offices, setOffices] = useState()
  const [loading, setLoading] = useState(true)
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [datetime, setDatetime] = useState(new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().substring(0, 19))
  const [error, setError] = useState()

  document.title = t("titleappname") + t("title_meetings")

  useEffect(() => {
    if (offices == undefined && meetings === undefined) {
      let isApiSubscribed = true;

      async function readMeetingsInternal() {
        const offices = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/offices");
        if (offices.length > 0) {
          const officeId = offices[0]._id
          const result = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/meetings/" + officeId);
          if (isApiSubscribed) {
            setOfficeId(officeId)
            setOffices(offices)
            setMeetings(result.meetings)
            setLoading(false)
          }
        }
        if (isApiSubscribed) {
          setLoading(false)
        }
      }

      readMeetingsInternal()

      return () => {
        //TODO: cancel the request before component unmounts
        isApiSubscribed = false
      };
    }
  })

  const readMeetings = async () => {
    let url = process.env.REACT_APP_SERVER_BASE_URL + "/meetings/" + officeId
    const result = await getJson(url);

    setMeetings(result.meetings)
    setLoading(false)
  }

  const createMeeting = async () => {
    let url = process.env.REACT_APP_SERVER_BASE_URL + "/meetings"
    try {
      debugger
      await postJson(url, { officeId, participants: [{ name, email }], datetime: new Date(datetime) })
      await readMeetings()
    } catch (error) {
      setError("AAA" + error)
    }
  }

  const copyLink = (link) => {

    navigator.clipboard.writeText(link).then(function () {
      /* clipboard successfully set */
    }, function () {
      /* clipboard write failed */
    });
  }


  if (loading) {
    return <div className="spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  } if (!offices) {
    return <div >
      You don't have offices yet. Contact us to buy ...
    </div>
  } else {
    return <div >

      <h3>{t("title_meetings")}</h3>

      {error ? <div className="text-danger"><b>{error}</b><br /></div> :
        <div className="wrap-input100 validate-input">
          <input className="form-control w-270"
            type="datetime-local"
            id="datetime"
            placeholder="Select time"
            value={datetime}
            onChange={(e) => setDatetime(e.target.value)}
            style={{ width: "auto", display: "inline-block", marginRight: "20px" }} />

          <input className="form-control"
            id="name"
            placeholder="Guest Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: "auto", display: "inline-block", marginRight: "20px" }} />

          <input className="form-control"
            id="email"
            placeholder="Guest Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "auto", display: "inline-block", marginRight: "20px" }} />

          <button className="submit-btn" onClick={createMeeting}>Create meeting</button>
        </div>
      }
      <br />
      {!(meetings && meetings.length > 0) ?
        <div >
          No upcoming meetings
        </div> :
        <div>
          <div>
            <i>Upcomming meetings</i>
          </div>
          <br />
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Date/Time</th>
                <th scope="col">Participant(s)</th>
                <th scope="col">Link</th>
              </tr>
            </thead>
            <tbody>
              {meetings.map(meeting =>
                <tr key={meeting._id}>
                  <td>{new moment.utc(meeting.ts).format("LLLL")}</td>
                  <td>{meeting.participants.map(p => `${p.name} (${p.email})`)}</td>
                  <td><input type="text" readOnly={true} value={meeting.link} style={{ width: "600px" }}></input><button className="submit-btn-2" onClick={() => copyLink(meeting.link)}>Copy link</button></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>}
    </div>
  }

}

export default MeetingsPage
